import React from 'react';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import { comBrandOptions, ecuTypeOptions } from './AppDocuCommon';

const ComBrandFormatter = ({ value }) => {
  const comBrand = comBrandOptions.find(opt => opt.name === value);
  return (
    <span style={{
      fontSize: 13,
      fontWeight: 700,
      color: comBrand ? comBrand.color : '#333',
      display: 'inline-block',
      minWidth: 32,
      textAlign: 'left',
      letterSpacing: 0.5
    }}>
      {value}
    </span>
  );
};
const ComBrandTypeProvider = props => <DataTypeProvider formatterComponent={ComBrandFormatter} {...props} />

export default ComBrandTypeProvider;
